import React from 'react';
import { homeFaqs } from '../data/homeFaqs';

export default function FAQ() {
  return <section id="faq" className="hbk-section" data-testid="faq-section"><div className="max-w-4xl mx-auto px-4">
    <p className="section-marker" data-testid="faq-label">YOUR QUESTIONS, ANSWERED</p>
    <h2 className="section-heading mb-8" data-testid="faq-heading">A Few Things to Know</h2>
    {homeFaqs.map(({ question, answer }, index) => <details key={question} className="border-t border-[var(--line-strong)] py-2" data-testid={`faq-item-${String(index + 1).padStart(2, '0')}`}>
      <summary className="hbk-detail-summary text-lg" data-testid={`faq-toggle-${index + 1}`}><h3 className="inline text-lg font-bold" data-testid={`faq-question-${index + 1}`}>{question}</h3></summary>
      <div className="text-base text-[#2a3950] pb-5 space-y-3" data-testid={`faq-answer-${index + 1}`}>{answer.map((paragraph, part) => <p key={paragraph} data-testid={`faq-answer-${index + 1}-part-${part + 1}`}>{paragraph}</p>)}</div>
    </details>)}
  </div></section>;
}